import { FC } from 'react';
import { ModalWrapper } from '../ModalWrapper';
import { ObjectiveForm, ObjectiveFormValues } from './ObjectiveForm';

interface ObjectiveModalProps {
  open: boolean;
  onClose: () => void;
  initialValues: ObjectiveFormValues;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: (values: ObjectiveFormValues) => void | Promise<any>;
}

export const ObjectiveModal: FC<ObjectiveModalProps> = ({ open, onClose, initialValues, onSubmit }) => {
  return (
    <ModalWrapper title='Edit Objective' open={open} onClose={onClose}>
      <ObjectiveForm onClose={onClose} initialValues={initialValues} onSubmit={onSubmit} />
    </ModalWrapper>
  );
};
